import React from 'react';
import styled from 'styled-components';

const API = process.env.REACT_APP_API_URL || '';

const ERROR_MESSAGES = {
  not_allowed: "That Google account isn't on the access list yet. Ask an existing user to add it.",
  invalid_state: 'Login session expired — try again.',
  login_failed: 'Something went wrong signing in — try again.'
};

function Login({ error, googleConfigured }) {
  return (
    <Page>
      <Card>
        <Title>Sign in</Title>
        <Subtitle>Access is limited to approved accounts</Subtitle>

        {error && ERROR_MESSAGES[error] && (
          <ErrorMsg>{ERROR_MESSAGES[error]}</ErrorMsg>
        )}

        {googleConfigured ? (
          <GoogleBtn href={`${API}/auth/google`}>
            <GoogleIcon />
            Sign in with Google
          </GoogleBtn>
        ) : (
          <ErrorMsg>Google login isn't configured on this server yet.</ErrorMsg>
        )}
      </Card>
    </Page>
  );
}

function GoogleIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 18 18">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 01-1.8 2.72v2.26h2.9c1.7-1.57 2.7-3.88 2.7-6.62z"/>
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.9-2.26c-.8.54-1.83.86-3.06.86-2.35 0-4.34-1.59-5.05-3.72H.96v2.33A9 9 0 009 18z"/>
      <path fill="#FBBC05" d="M3.95 10.7A5.4 5.4 0 013.68 9c0-.59.1-1.17.27-1.7V4.97H.96A9 9 0 000 9c0 1.45.35 2.83.96 4.03l2.99-2.33z"/>
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0A9 9 0 00.96 4.97L3.95 7.3C4.66 5.17 6.65 3.58 9 3.58z"/>
    </svg>
  );
}

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg);
  padding: 24px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 400px;
  background: var(--bg-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 40px 36px;
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Title = styled.h1`
  font-family: var(--font-display);
  font-size: 26px;
  font-weight: 600;
  color: var(--text);
  letter-spacing: -0.3px;
  margin-bottom: 6px;
  margin-top: 4px;
`;

const Subtitle = styled.p`
  color: var(--text-2);
  font-size: 13px;
  margin-bottom: 28px;
`;

const GoogleBtn = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px;
  background: var(--bg-2);
  border: 1px solid var(--border-2);
  color: var(--text);
  font-family: var(--font-ui);
  font-weight: 600;
  font-size: 13.5px;
  border-radius: var(--radius);
  text-decoration: none;
  transition: all 0.15s;
  &:hover { background: var(--bg-3); border-color: var(--text-3); }
`;

const ErrorMsg = styled.div`
  width: 100%;
  padding: 10px 14px;
  background: var(--red-dim);
  border: 1px solid var(--red);
  border-radius: var(--radius);
  color: var(--red);
  font-size: 12px;
  margin-bottom: 20px;
  line-height: 1.4;
`;

export default Login;
